enum FIELD_TYPE {
    M = "Mandatory",
    O = "Optional",
    N = "Not Expected"
}

export default FIELD_TYPE;